var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center"},[_c('div',[_vm._v("I am a dynamic-submodule-2 state key: "+_vm._s(_vm.dynamic_submodule_2_state_key))]),_c('b-button',{staticClass:"ml-2 my-1",attrs:{"size":"sm","variant":"info"},on:{"click":function($event){_vm.dynamic_submodule_2_state_key++}}},[_vm._v("click to increment")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }